export abstract class RouteBase {
  protected constructor(
    protected id: number,
    protected discriminator: string,
    protected comment: string,
  ) {}

  public getId(): number {
    return this.id;
  }
  public getDiscriminator(): string {
    return this.discriminator;
  }
  public getComment(): string {
    return this.comment;
  }
  public setComment(param: string) {
    this.comment = param;
  }
}
